export default "__VITE_ASSET__NHXbnjA5__"